import React from 'react';
import Page from '../core/screens/Page';
import {ReactComponent as Logo} from '../assets/svg/home_logo.svg';
import '../css/screens/HomePage.scss';
import Grid from '../responsive/Grid';
import Button from '../ui/Button';
import { HomeLogo, HomePlayBtn, HomeBanner } from '../ui/Vectors';
import Spacer from '../ui/Spacer';
import YoutubeLightbox from '../ui/YoutubeLightbox';
import { History, HistoryEvent } from '../router/History';

export default class HomePage extends Page
{
	lightbox:YoutubeLightbox;
	playBtn;

	componentDidMount()
	{
		this.playBtn.addEventListener('click', this._playClick);
		this.history.on(HistoryEvent.CHANGE, this._historyChange);
	}

	componentWillUnmount()
	{
		this.playBtn.removeEventListener('click', this._playClick);
		this.history.off(HistoryEvent.CHANGE, this._historyChange);
	}

	private _playClick = () =>
	{
		if(this.lightbox) this.lightbox.show();
	}

	private _historyChange = () =>
	{
		if(this.lightbox) this.lightbox.hide();
	}

	render()
	{
		let textDesktop = this.props.content.text.split('\r').join('');
		let textMobile = this.props.content.text.split('\n').join('').split('\r').join('\n');
		return this.wrap(<div>
			<Grid cols={4} skip={0} breakpoints={{'small': {cols: 4, skip: 0}}}>
				<BG data={this.props.content.cover}></BG>
				<div className="content">
					<div className='logo'>
						<HomeLogo></HomeLogo>
					</div>
					<h1>{this.props.content.title}</h1>
					<div className='text hide-small text-center'>{textDesktop}</div>
					<div className='text show-small text-center'>{textMobile}</div>
					<div className='text-center'>
						<a ref={r => this.playBtn = r} className="playBtn">
							<HomePlayBtn></HomePlayBtn>
						</a>
					</div>
				</div>
				<YoutubeLightbox ref={r => this.lightbox = r} data={this.props.content.youtube}></YoutubeLightbox>
			</Grid>
		</div>);
	}
}

class BG extends React.Component<{data:any}>
{
	render()
	{
		return (
			<div className="coverVideo">
				<video poster={this.props.data.poster} autoPlay={true} loop={true} controls={null} muted={true} playsInline={true}>
					<source src={this.props.data.video} type="video/mp4"/>
				</video>
			</div>
		)
	}
}